
import addJquery from './../../common/addJquery.js'

import pageSe from './moudle/pageSelect.js'

console.log('commercisl   1');

function loadContent(){
	var page = pageSe(window.commercial.common.commonType);
	(function(jq){
		var entrance = true;

		if(jq){
			entrance = page&&addJquery(page, 1);
		} else{
			entrance =  page&&page.init();
		}
	})(!(window.jQuery||window.$))
}

function hasCommon(){
	if(window.commercial&&window.commercial.common){
		var type = window.commercial.common.commonType,
			youpei = (type==21||type==22||type==25||type==26);
		if(window.commercial.entityidlist===undefined&&youpei){
			return false;
		}
		console.log('commercisl   2');
	 	loadContent();
	 	return true;
	}else{
		return false;
	}
}

if(!hasCommon()){
	 var waitCommon = setInterval(function(){
	 	if(hasCommon()){
	 		clearInterval(waitCommon);
	 	}
	 },200)
}

setTimeout(function(){
	clearInterval(waitCommon);
},300000);





